export default "__VITE_ASSET__tBxI1slA__"